module.exports = __webpack_public_path__ + "static/network-overview-65a3162bd006a17638d88990d3fbdadf.png";